import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import SendIcon from "@mui/icons-material/Send";

const FormSendMessage = ({
  handleSend,
  handleEmojiShow,
  mensagem,
  handleChange,
  hiddenFileInput,
  handleChangeFile,
  isAttachingFile,
  handleAttachFile,
  isSending,
}) => {
  const podeEnviar = mensagem.trim().length > 0 && !isSending;

  return (
    <Box
      component="form"
      onSubmit={handleSend}
      sx={{ display: "flex", alignItems: "flex-end", gap: 0.5, pt: 1.5 }}
    >
      <Tooltip title="Emojis">
        <IconButton onClick={handleEmojiShow}>
          <EmojiEmotionsOutlinedIcon />
        </IconButton>
      </Tooltip>

      <input type="file" hidden ref={hiddenFileInput} onChange={handleChangeFile} />
      <Tooltip title="Anexar arquivo">
        <span>
          <IconButton onClick={handleAttachFile} disabled={isAttachingFile}>
            {isAttachingFile ? <CircularProgress size={22} /> : <AttachFileIcon />}
          </IconButton>
        </span>
      </Tooltip>

      <TextField
        size="small"
        fullWidth
        multiline
        maxRows={5}
        placeholder="Digite uma mensagem"
        autoFocus
        value={mensagem}
        onChange={handleChange}
        onKeyDown={(event) => {
          // Enter envia; Shift+Enter quebra a linha.
          if (event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing) {
            event.preventDefault();
            handleSend(event);
          }
        }}
        slotProps={{ htmlInput: { maxLength: 1000 } }}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
      />

      <Tooltip title="Enviar">
        <span>
          <IconButton type="submit" color="primary" disabled={!podeEnviar}>
            {isSending ? <CircularProgress size={22} /> : <SendIcon />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default FormSendMessage;
